module.exports = __webpack_public_path__ + "static/pullquote-3950134bd3b75eb705c060e803cc7eaf.svg";